import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#dispositionskredit

	{
		"abloesen": true | false,
		"beanspruchterBetrag": schemaBigDecimal,
		"bic": String,
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"glaeubiger": String,
		"iban": String,
		"kreditinstitut": String,
		"verfuegungsrahmen": schemaBigDecimal,
		"zinssatz": schemaBigDecimal
	}

*/
export const schemaEuropaceDispositionskredit = z.object({
    abloesen: z.optional(z.boolean()),
    beanspruchterBetrag: z.optional(schemaBigDecimal),
    bic: z.optional(z.string()),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    glaeubiger: z.optional(z.string()),
    iban: z.optional(z.string()),
    id: z.string().min(1),
    kreditinstitut: z.optional(z.string()),
    verfuegungsrahmen: z.optional(schemaBigDecimal),
    zinssatz: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceDispositionskredit = z.infer<typeof schemaEuropaceDispositionskredit>;
